// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRESUPUESTADOR_VALIDATE_PATENT_APPRAISED
} from './constants'
import validatePatente from '../../common/backend/validatePatente'

export function validatePatentAppraised(patente, errorPeritaje) {
  return (dispatch, getState) => {
    if(patente){
      if (!validatePatente(patente)) {
        const error = 'Ingresá una patente válida'
        dispatch({
          type: PRESUPUESTADOR_VALIDATE_PATENT_APPRAISED,
          data: {
            patenteCodeError: {
              code: 'invalid',
              message: error
            },
            errorPatente: error
          },
        })
        return false
      }

      const state = getState()
      const existePatente = state.presupuestador.entregaUsados.some((item) => item.patente === patente)

      if (existePatente) {
        const error = 'La patente ya fue cargada'
        dispatch({
          type: PRESUPUESTADOR_VALIDATE_PATENT_APPRAISED,
          data: {
            patenteCodeError: {
              code: 'repeat',
              message: error
            },
            errorPatente: error,
          },
        })
        return false
      }
    } else {
      dispatch({
        type: PRESUPUESTADOR_VALIDATE_PATENT_APPRAISED,
        data: {
          patenteCodeError: null,
          errorPatente: errorPeritaje,
        }
      })
      return false
    }

    dispatch({ type: PRESUPUESTADOR_VALIDATE_PATENT_APPRAISED, data: {patenteCodeError: null, errorPatente: ""} })
    return true
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_VALIDATE_PATENT_APPRAISED:
      return {
        ...state,
        ...action.data
      };

    default:
      return state;
  }
}
